import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

export default function SystemNotificationToast({ message }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/system/notifications'); // your system notifications page
  };

  return (
    <div
      className="flex items-center max-w-sm p-2 mx-auto space-x-4 text-white bg-green-600 rounded-lg shadow-md bg-opacity-20 backdrop-blur-md w-80 cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex-1">
        <h2 className="text-lg font-semibold">
          {message.title || 'System Notification'}
        </h2>
        <p className="mt-1 text-base line-clamp-1">
          {message.body || message.textMessage}
        </p>
      </div>
    </div>
  );
}

SystemNotificationToast.propTypes = {
  message: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    textMessage: PropTypes.string,
  }).isRequired,
};
